/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchSaveBlockedSellersRequest,
    BatchSortCategorizedResourceRequest,
    BatchSortCategoryDiscoveryRowsRequest,
    CategoryBatchImportResponse,
    CategoryDiscoveryRowSellerIdsResponse,
    CreateCategorizedResourceRequest,
    CreateCategoryDiscoveryRowRequest,
    CreateCategoryRequest,
    CreateCategoryResponse,
    EditCategoryRequest,
    IdResponse,
    PatchCategoryDiscoveryRowRequest,
} from '../models';

export interface CategoriesApiControllerAddUserInterestRequest {
    categoryId: string;
}

export interface CategoriesApiControllerBatchImportStoresRequest {
    categoryId: string;
    file?: Blob;
}

export interface CategoriesApiControllerBatchSaveBlockedSellersRequest {
    categoryDiscoveryRowId: string;
    batchSaveBlockedSellersRequest: BatchSaveBlockedSellersRequest;
}

export interface CategoriesApiControllerBatchSortCategorizedResourceRequest {
    batchSortCategorizedResourceRequest: BatchSortCategorizedResourceRequest;
}

export interface CategoriesApiControllerBatchSortCategoryDiscoveryRowsRequest {
    batchSortCategoryDiscoveryRowsRequest: BatchSortCategoryDiscoveryRowsRequest;
}

export interface CategoriesApiControllerCreateCategorizeDiscoveryRowRequest {
    createCategoryDiscoveryRowRequest: CreateCategoryDiscoveryRowRequest;
}

export interface CategoriesApiControllerCreateCategoryRequest {
    createCategoryRequest: CreateCategoryRequest;
}

export interface CategoriesApiControllerCreateLiveStreamCategorizedResourceRequest {
    categoryId: string;
    createCategorizedResourceRequest: CreateCategorizedResourceRequest;
}

export interface CategoriesApiControllerCreateStoreCategorizedResourceRequest {
    categoryId: string;
    createCategorizedResourceRequest: CreateCategorizedResourceRequest;
}

export interface CategoriesApiControllerCreateUpcomingShowCategorizedResourceRequest {
    categoryId: string;
    createCategorizedResourceRequest: CreateCategorizedResourceRequest;
}

export interface CategoriesApiControllerCreateUserCategorizedResourceRequest {
    categoryId: string;
    createCategorizedResourceRequest: CreateCategorizedResourceRequest;
}

export interface CategoriesApiControllerEditCategoryRequest {
    categoryId: string;
    editCategoryRequest: EditCategoryRequest;
}

export interface CategoriesApiControllerEligibleCategoryDiscoveryRowSellerIdsRequest {
    categoryDiscoveryRowId: string;
}

export interface CategoriesApiControllerPatchCategorizeDiscoveryRowRequest {
    categoryDiscoveryRowId: string;
    patchCategoryDiscoveryRowRequest: PatchCategoryDiscoveryRowRequest;
}

export interface CategoriesApiControllerRemoveCategorizeDiscoveryRowRequest {
    categoryDiscoveryRowId: string;
}

export interface CategoriesApiControllerRemoveLiveStreamsCategorizedResourceRequest {
    categoryId: string;
    resourceId: string;
}

export interface CategoriesApiControllerRemoveStoreCategorizedResourceRequest {
    categoryId: string;
    resourceId: string;
}

export interface CategoriesApiControllerRemoveUpcomingShowCategorizedResourceRequest {
    categoryId: string;
    resourceId: string;
}

export interface CategoriesApiControllerRemoveUserCategorizedResourceRequest {
    categoryId: string;
    resourceId: string;
}

export interface CategoriesApiControllerRemoveUserInterestRequest {
    categoryId: string;
}

/**
 * 
 */
export class CategoriesApi extends runtime.BaseAPI {

    /**
     */
    async categoriesApiControllerAddUserInterestRaw(requestParameters: CategoriesApiControllerAddUserInterestRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerAddUserInterest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}:like`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerAddUserInterest(requestParameters: CategoriesApiControllerAddUserInterestRequest): Promise<void> {
        await this.categoriesApiControllerAddUserInterestRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerBatchImportStoresRaw(requestParameters: CategoriesApiControllerBatchImportStoresRequest): Promise<runtime.ApiResponse<CategoryBatchImportResponse>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerBatchImportStores.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/categories/{categoryId}/stores:batch-import`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerBatchImportStores(requestParameters: CategoriesApiControllerBatchImportStoresRequest): Promise<CategoryBatchImportResponse> {
        const response = await this.categoriesApiControllerBatchImportStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async categoriesApiControllerBatchSaveBlockedSellersRaw(requestParameters: CategoriesApiControllerBatchSaveBlockedSellersRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling categoriesApiControllerBatchSaveBlockedSellers.');
        }

        if (requestParameters.batchSaveBlockedSellersRequest === null || requestParameters.batchSaveBlockedSellersRequest === undefined) {
            throw new runtime.RequiredError('batchSaveBlockedSellersRequest','Required parameter requestParameters.batchSaveBlockedSellersRequest was null or undefined when calling categoriesApiControllerBatchSaveBlockedSellers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows/{categoryDiscoveryRowId}/blocked-sellers:batchSave`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSaveBlockedSellersRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerBatchSaveBlockedSellers(requestParameters: CategoriesApiControllerBatchSaveBlockedSellersRequest): Promise<void> {
        await this.categoriesApiControllerBatchSaveBlockedSellersRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerBatchSortCategorizedResourceRaw(requestParameters: CategoriesApiControllerBatchSortCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchSortCategorizedResourceRequest === null || requestParameters.batchSortCategorizedResourceRequest === undefined) {
            throw new runtime.RequiredError('batchSortCategorizedResourceRequest','Required parameter requestParameters.batchSortCategorizedResourceRequest was null or undefined when calling categoriesApiControllerBatchSortCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categorized-resources:batchSort`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortCategorizedResourceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerBatchSortCategorizedResource(requestParameters: CategoriesApiControllerBatchSortCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerBatchSortCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerBatchSortCategoryDiscoveryRowsRaw(requestParameters: CategoriesApiControllerBatchSortCategoryDiscoveryRowsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchSortCategoryDiscoveryRowsRequest === null || requestParameters.batchSortCategoryDiscoveryRowsRequest === undefined) {
            throw new runtime.RequiredError('batchSortCategoryDiscoveryRowsRequest','Required parameter requestParameters.batchSortCategoryDiscoveryRowsRequest was null or undefined when calling categoriesApiControllerBatchSortCategoryDiscoveryRows.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows:batchSort`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortCategoryDiscoveryRowsRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerBatchSortCategoryDiscoveryRows(requestParameters: CategoriesApiControllerBatchSortCategoryDiscoveryRowsRequest): Promise<void> {
        await this.categoriesApiControllerBatchSortCategoryDiscoveryRowsRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerCreateCategorizeDiscoveryRowRaw(requestParameters: CategoriesApiControllerCreateCategorizeDiscoveryRowRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.createCategoryDiscoveryRowRequest === null || requestParameters.createCategoryDiscoveryRowRequest === undefined) {
            throw new runtime.RequiredError('createCategoryDiscoveryRowRequest','Required parameter requestParameters.createCategoryDiscoveryRowRequest was null or undefined when calling categoriesApiControllerCreateCategorizeDiscoveryRow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCategoryDiscoveryRowRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerCreateCategorizeDiscoveryRow(requestParameters: CategoriesApiControllerCreateCategorizeDiscoveryRowRequest): Promise<IdResponse> {
        const response = await this.categoriesApiControllerCreateCategorizeDiscoveryRowRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async categoriesApiControllerCreateCategoryRaw(requestParameters: CategoriesApiControllerCreateCategoryRequest): Promise<runtime.ApiResponse<CreateCategoryResponse>> {
        if (requestParameters.createCategoryRequest === null || requestParameters.createCategoryRequest === undefined) {
            throw new runtime.RequiredError('createCategoryRequest','Required parameter requestParameters.createCategoryRequest was null or undefined when calling categoriesApiControllerCreateCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCategoryRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerCreateCategory(requestParameters: CategoriesApiControllerCreateCategoryRequest): Promise<CreateCategoryResponse> {
        const response = await this.categoriesApiControllerCreateCategoryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async categoriesApiControllerCreateLiveStreamCategorizedResourceRaw(requestParameters: CategoriesApiControllerCreateLiveStreamCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerCreateLiveStreamCategorizedResource.');
        }

        if (requestParameters.createCategorizedResourceRequest === null || requestParameters.createCategorizedResourceRequest === undefined) {
            throw new runtime.RequiredError('createCategorizedResourceRequest','Required parameter requestParameters.createCategorizedResourceRequest was null or undefined when calling categoriesApiControllerCreateLiveStreamCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/liveStreams`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCategorizedResourceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerCreateLiveStreamCategorizedResource(requestParameters: CategoriesApiControllerCreateLiveStreamCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerCreateLiveStreamCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerCreateStoreCategorizedResourceRaw(requestParameters: CategoriesApiControllerCreateStoreCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerCreateStoreCategorizedResource.');
        }

        if (requestParameters.createCategorizedResourceRequest === null || requestParameters.createCategorizedResourceRequest === undefined) {
            throw new runtime.RequiredError('createCategorizedResourceRequest','Required parameter requestParameters.createCategorizedResourceRequest was null or undefined when calling categoriesApiControllerCreateStoreCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/stores`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCategorizedResourceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerCreateStoreCategorizedResource(requestParameters: CategoriesApiControllerCreateStoreCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerCreateStoreCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerCreateUpcomingShowCategorizedResourceRaw(requestParameters: CategoriesApiControllerCreateUpcomingShowCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerCreateUpcomingShowCategorizedResource.');
        }

        if (requestParameters.createCategorizedResourceRequest === null || requestParameters.createCategorizedResourceRequest === undefined) {
            throw new runtime.RequiredError('createCategorizedResourceRequest','Required parameter requestParameters.createCategorizedResourceRequest was null or undefined when calling categoriesApiControllerCreateUpcomingShowCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/upcomingShows`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCategorizedResourceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerCreateUpcomingShowCategorizedResource(requestParameters: CategoriesApiControllerCreateUpcomingShowCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerCreateUpcomingShowCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerCreateUserCategorizedResourceRaw(requestParameters: CategoriesApiControllerCreateUserCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerCreateUserCategorizedResource.');
        }

        if (requestParameters.createCategorizedResourceRequest === null || requestParameters.createCategorizedResourceRequest === undefined) {
            throw new runtime.RequiredError('createCategorizedResourceRequest','Required parameter requestParameters.createCategorizedResourceRequest was null or undefined when calling categoriesApiControllerCreateUserCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/users`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCategorizedResourceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerCreateUserCategorizedResource(requestParameters: CategoriesApiControllerCreateUserCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerCreateUserCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerEditCategoryRaw(requestParameters: CategoriesApiControllerEditCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerEditCategory.');
        }

        if (requestParameters.editCategoryRequest === null || requestParameters.editCategoryRequest === undefined) {
            throw new runtime.RequiredError('editCategoryRequest','Required parameter requestParameters.editCategoryRequest was null or undefined when calling categoriesApiControllerEditCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editCategoryRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerEditCategory(requestParameters: CategoriesApiControllerEditCategoryRequest): Promise<void> {
        await this.categoriesApiControllerEditCategoryRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerEligibleCategoryDiscoveryRowSellerIdsRaw(requestParameters: CategoriesApiControllerEligibleCategoryDiscoveryRowSellerIdsRequest): Promise<runtime.ApiResponse<CategoryDiscoveryRowSellerIdsResponse>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling categoriesApiControllerEligibleCategoryDiscoveryRowSellerIds.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows/{categoryDiscoveryRowId}:sellerIds`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerEligibleCategoryDiscoveryRowSellerIds(requestParameters: CategoriesApiControllerEligibleCategoryDiscoveryRowSellerIdsRequest): Promise<CategoryDiscoveryRowSellerIdsResponse> {
        const response = await this.categoriesApiControllerEligibleCategoryDiscoveryRowSellerIdsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async categoriesApiControllerPatchCategorizeDiscoveryRowRaw(requestParameters: CategoriesApiControllerPatchCategorizeDiscoveryRowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling categoriesApiControllerPatchCategorizeDiscoveryRow.');
        }

        if (requestParameters.patchCategoryDiscoveryRowRequest === null || requestParameters.patchCategoryDiscoveryRowRequest === undefined) {
            throw new runtime.RequiredError('patchCategoryDiscoveryRowRequest','Required parameter requestParameters.patchCategoryDiscoveryRowRequest was null or undefined when calling categoriesApiControllerPatchCategorizeDiscoveryRow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows/{categoryDiscoveryRowId}`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchCategoryDiscoveryRowRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerPatchCategorizeDiscoveryRow(requestParameters: CategoriesApiControllerPatchCategorizeDiscoveryRowRequest): Promise<void> {
        await this.categoriesApiControllerPatchCategorizeDiscoveryRowRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerRemoveCategorizeDiscoveryRowRaw(requestParameters: CategoriesApiControllerRemoveCategorizeDiscoveryRowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling categoriesApiControllerRemoveCategorizeDiscoveryRow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-discovery-rows/{categoryDiscoveryRowId}`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerRemoveCategorizeDiscoveryRow(requestParameters: CategoriesApiControllerRemoveCategorizeDiscoveryRowRequest): Promise<void> {
        await this.categoriesApiControllerRemoveCategorizeDiscoveryRowRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerRemoveLiveStreamsCategorizedResourceRaw(requestParameters: CategoriesApiControllerRemoveLiveStreamsCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerRemoveLiveStreamsCategorizedResource.');
        }

        if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
            throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling categoriesApiControllerRemoveLiveStreamsCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/liveStreams/{resourceId}`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerRemoveLiveStreamsCategorizedResource(requestParameters: CategoriesApiControllerRemoveLiveStreamsCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerRemoveLiveStreamsCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerRemoveStoreCategorizedResourceRaw(requestParameters: CategoriesApiControllerRemoveStoreCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerRemoveStoreCategorizedResource.');
        }

        if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
            throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling categoriesApiControllerRemoveStoreCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/stores/{resourceId}`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerRemoveStoreCategorizedResource(requestParameters: CategoriesApiControllerRemoveStoreCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerRemoveStoreCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerRemoveUpcomingShowCategorizedResourceRaw(requestParameters: CategoriesApiControllerRemoveUpcomingShowCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerRemoveUpcomingShowCategorizedResource.');
        }

        if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
            throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling categoriesApiControllerRemoveUpcomingShowCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/upcomingShows/{resourceId}`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerRemoveUpcomingShowCategorizedResource(requestParameters: CategoriesApiControllerRemoveUpcomingShowCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerRemoveUpcomingShowCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerRemoveUserCategorizedResourceRaw(requestParameters: CategoriesApiControllerRemoveUserCategorizedResourceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerRemoveUserCategorizedResource.');
        }

        if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
            throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling categoriesApiControllerRemoveUserCategorizedResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}/users/{resourceId}`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerRemoveUserCategorizedResource(requestParameters: CategoriesApiControllerRemoveUserCategorizedResourceRequest): Promise<void> {
        await this.categoriesApiControllerRemoveUserCategorizedResourceRaw(requestParameters);
    }

    /**
     */
    async categoriesApiControllerRemoveUserInterestRaw(requestParameters: CategoriesApiControllerRemoveUserInterestRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling categoriesApiControllerRemoveUserInterest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/categories/{categoryId}:like`.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async categoriesApiControllerRemoveUserInterest(requestParameters: CategoriesApiControllerRemoveUserInterestRequest): Promise<void> {
        await this.categoriesApiControllerRemoveUserInterestRaw(requestParameters);
    }

}
